/** Simple in-memory cache for email search/analyze results with TTL */

interface CacheEntry {
  data: any;
  expiresAt: number;
}

const cache = new Map<string, CacheEntry>();
const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 minutes

function buildKey(action: string, params: Record<string, any>): string {
  const sorted = Object.keys(params)
    .sort()
    .reduce((acc, k) => {
      if (params[k] !== undefined && params[k] !== null) acc[k] = params[k];
      return acc;
    }, {} as Record<string, any>);
  return `${action}:${JSON.stringify(sorted)}`;
}

export function getCached(action: string, params: Record<string, any>): any | null {
  const key = buildKey(action, params);
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function setCache(action: string, params: Record<string, any>, data: any, ttlMs = DEFAULT_TTL_MS) {
  const key = buildKey(action, params);
  cache.set(key, { data, expiresAt: Date.now() + ttlMs });
  // Evict old entries if cache grows too large
  if (cache.size > 50) {
    const now = Date.now();
    for (const [k, v] of cache) {
      if (now > v.expiresAt) cache.delete(k);
    }
  }
}

export function clearEmailCache() {
  cache.clear();
}
